import React from "react";
import { SearchBasicSelectUI } from "../../../../../ui/SearchBasicSelectUI";

export const DetalleComprobanteMovimientoSelect = ({ data, ...restProps }) => {
  return <SearchBasicSelectUI data={data} {...restProps} />;
};
